import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import { countriesQuery } from '@app/pcs/settings/data/country.queries';

@Injectable()
export class CountryDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  getCountries() {
    return this.graphqlService.query(countriesQuery);
  }
}
